import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useAuth } from '../AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import '../Pricing.css';
import UserStatus from './UserStatus';
import { useNavigate } from 'react-router-dom';
import API from '../api';


function Change_Plan() {
  const { user } = useAuth();
  const [subscription, setSubscription] = useState('');
  const userId = user?.id;
  const [selected, setSelected] = useState('');
  const [selectedPlan, setSelectedPlan] = useState({id:'', name:'', price: '', action: ''});  
  const navigate = useNavigate();
const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth >= 769);
  
useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 769) {
        setSidebarOpen(true);  // open sidebar on desktop
      } else {
        setSidebarOpen(false); // closed on mobile
      }
    };

    handleResize(); // run on mount

    // Optional: listen for window resize to update sidebar automatically
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };
  
const plans = [
  {
    id: 2,
    name: 'Silver',
    price: 'Tk 300/month',
    features: ['For up to 5 stocks', 'Telegram / SMS Notification', 'Price and News Notification', 'Billed Monthly'],
    button: 'Choose Silver',
    link: '/payment'
  },
  {
    id: 3,
    name: 'Gold',
    price: 'Tk 500/month',
    features: ['For up to 10 stocks', 'Telegram / SMS Notification', 'Price and News Notification', 'Billed Monthly'],
    button: 'Choose Gold',
    link: '/payment'
  }, 
  {
    id: 4,
    name: 'Platinum',
    price: 'Tk 1000/month',
    features: ['For up to 25 stocks', 'Telegram / SMS Notification', 'Price and News Notification', 'Billed Monthly'],
    button: 'Choose Platinum',
    link: '/payment'
  }
];

useEffect(() => {
  document.title = "Change Plan | TradeBarta.com";
}, []);

  useEffect(() => {
    fetchSubscription();
  }, [userId]);

  const fetchSubscription = async () => {
    try {
      if (user) {
        const res = await API.get('/packageid', { params: { user_id: user.id } });
        const planId = res.data.package_id;
        const planName = planId === '' ? '' : 
                         planId === 1 ? 'Free Trial' :
                         planId === 2 ? 'Silver' :
                         planId === 3 ? 'Gold' : 
                         planId === 4 ? 'Platinum': '';
        setSubscription(planName);
      }
    } catch (err) {
      console.error('Subscription load failed', err);
    }
  };

  // Filter plans based on current subscription
  const getFilteredPlans = () => {
    if (subscription === 'Free Trial' || subscription === '') return plans;
    if (subscription === 'Silver') return plans.slice(1); // Gold, Platinum
    if (subscription === 'Gold') return plans.slice(2); // Platinum
    if (subscription === 'Platinum') return [];           // no higher plan
    return []; // fallback for unexpected values

  };

const filteredPlans = getFilteredPlans();
const handle_change = (plan) => {    
  console.log("Plan clicked:", plan);

  let updatedPlan = {};

  if (plan.name === 'Silver') {
    updatedPlan = { id: 2, name: 'Silver', price: '300/month', action: 'change', features: ['For up to 5 stocks', 'Telegram / SMS Notification', 'Price and News Notification', 'Billed Monthly']};
  } else if (plan.name === 'Gold') {
    updatedPlan = { id: 3, name: 'Gold', price: '500/month', action: 'change', features: ['For up to 10 stocks', 'Telegram / SMS Notification', 'Price and News Notification', 'Billed Monthly']};
  } else if (plan.name === 'Platinum') {
    updatedPlan = { id: 4, name: 'Platinum', price: '1000/month', action: 'change', features: ['For up to 25 stocks', 'Telegram / SMS Notification', 'Price and News Notification', 'Billed Monthly'] };
  }

//  setSelectedPlan(updatedPlan);

  console.log('Redirecting with plan:', updatedPlan); 
  navigate('/payment', { state: { selectedPlan: updatedPlan } });
};

  return (
<div className='dashboard-wrapper'>
          {/* Top Navigation Bar */}
      <header className="header-container">
  <a href="/" className="logo">
    <img src={require("../images/logo.png")} alt="Logo" />
  </a>

                     
                    <button className="menu-toggle" onClick={toggleSidebar}>☰</button>  
     <UserStatus />
          </header>       
      {/* Sidebar and Main Content */}
                    
   <div className={`dashboard-container ${sidebarOpen ? 'sidebar-open' : ''}`}>
  
     <aside className={`sidebar ${sidebarOpen ? 'show-sidebar' : ''}`}>
             <ul>
                <li><a href="/dashboard">Dashboard</a></li>
                <li><a href="/payment_history">Billing and Payment History</a></li>
                <li><a href="/referral_dashboard">Refer & Win</a></li>
                <li><a href="/profile">My Profile</a></li>
                <li><a href="/contact_us">Support</a></li>
             </ul>
            </aside>

      <main className="main-content">
          {filteredPlans.length === 0 ? (
            <p style={{fontSize: '20px', color: 'red'}}>You are already on the highest available plan.</p>
          ) : (      
          <div className="pricing-container">
          <h1>Choose Your Plan</h1>
          <div className="pricing-cards">
              {filteredPlans.map((plan, index) => (
                <div className="pricing-card" key={index}>
                  <h2>{plan.name}</h2>
                  <p className="price">{plan.price}</p>
                  <ul>
                    {plan.features.map((feature, i) => (
                      <li key={i}>{feature}</li>
                    ))}
                  </ul>
      <a href="#" onClick={(e) => { e.preventDefault(); handle_change(plan);  }} 
            className="btn"> {plan.button}</a> 
                  
                </div>
              ))}
            </div>
        </div>
        )}
        
      </main>
    </div>
    </div>
  );
}

export default Change_Plan;